import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import Button from 'components/Common/Buttons';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ModalWrapper from 'components/Modals/ModalWrapper';

const FormConfirmation = ({
  onConfirm,
  onCancel,
  previewOnlyMode,
  isFetchingPdf,
  downloadFormType,
  onClickHandler,
  formGroup,
  formTypes,
  showAffidavit,
  supportingDocOnClickHandler,
  isFetchingCollectablePdf,
  isConfirmingForm
}) => {
  const intl = useIntl();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const formConfirmationTitle = <h1><LocalisedMessage id="formPreview.generateFormPreview" /></h1>;
  const { formType } = useParams();

  const formConfirmationMessage = <span>
    <LocalisedMessage id={
      // eslint-disable-next-line no-nested-ternary
      previewOnlyMode ? 'formPreview.previewOnlyMode.content' : !formGroup ? 'formPreview.content' : 'formGroupPreview.content'
      }
    />
    <div className="mt-2">
      { formGroup && formGroup.formTypes.map(f => <Button
        id={ `${ f }-formPreviewBtn` }
        key={ f }
        // eslint-disable-next-line prefer-template
        value={ intl.formatMessage({ id: 'buttons.download.buttonText' }) + ` ${ formTypes.filter(ft => ft.formType === f) ? formTypes.filter(ft => ft.formType === f)[0].title : f.toUpperCase() }` }
        disabled={ isFetchingPdf }
        className={ `btn-secondary btn-download mr-0 ${ isFetchingPdf && downloadFormType === f ? 'btn-active' : '' }` }
        onClick={ () => onClickHandler(f) }
      />) }
      { !formGroup && <Button
        id="formPreviewBtn"
        value={ `${ intl.formatMessage({ id: isFetchingPdf ? 'formPreview.downloading.buttonText' : 'buttons.download.buttonText' }) } ${ formTypes.find(ft => ft.formType === formType.toLowerCase())?.title }` }
        disabled={ isFetchingPdf }
        className={ `btn-download-preview-pdf mr-0 ${ isFetchingPdf ? 'btn-active-download' : '' }` }
        onClick={ () => onClickHandler() }
      /> }
      { showAffidavit && <Button
        id="affidavitPreviewBtn"
        value={ intl.formatMessage({ id: isFetchingCollectablePdf ? 'formPreview.downloading.buttonText' : 'formPreview.download.affidavit.buttonText' }) }
        disabled={ isFetchingCollectablePdf }
        className={ `${ formGroup ? 'btn-secondary btn-download' : 'btn-download-preview-pdf' } mr-0 ${ isFetchingCollectablePdf && !formGroup ? 'btn-active-download' : '' } ${ isFetchingCollectablePdf && formGroup ? 'btn-active' : '' }` }
        onClick={ () => supportingDocOnClickHandler('AffidavitOfUnchangedStatus') }
      /> }
    </div>
    { !previewOnlyMode && <label className="form-checkbox">
      <input id="certifyCheckbox" type="checkbox" onClick={ () => setIsConfirmed(!isConfirmed) } />
      <i className="form-icon" />
      <LocalisedMessage id={ !formGroup ? 'formPreview.confirmLabel' : 'formGroupPreview.confirmLabel' } />
    </label> }
  </span>;

  return (
    <ModalWrapper
      title={ formConfirmationTitle }
      closeButtonName={ intl.formatMessage({ id: 'formPreview.generateFormPreview' }) }
      content={ formConfirmationMessage }
      onCancel={ onCancel }
      onConfirm={ onConfirm }
      showCancel={ false }
      disableConfirm={ (!previewOnlyMode && !isConfirmed) || isConfirmingForm }
      btnConfirmTitle={ intl.formatMessage({ id: 'formPreview.submit.buttonText' }) }
      footer={ !previewOnlyMode && !isConfirmed && <span className="confirmation-text"><LocalisedMessage id="formPreview.confirmMessage" /></span> }
    />
  );
};

FormConfirmation.defaultProps = {
  previewOnlyMode: false,
  isFetchingPdf: false,
  downloadFormType: null,
  formGroup: null,
  formTypes: [],
  showAffidavit: false,
  isFetchingCollectablePdf: false,
  isConfirmingForm: false
};

FormConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  isFetchingPdf: PropTypes.bool,
  downloadFormType: PropTypes.string,
  previewOnlyMode: PropTypes.bool,
  formGroup: PropTypes.shape({
    key: PropTypes.string,
    formTypes: PropTypes.arrayOf(PropTypes.string)
  }),
  formTypes: PropTypes.arrayOf(PropTypes.shape({})),
  showAffidavit: PropTypes.bool,
  supportingDocOnClickHandler: PropTypes.func.isRequired,
  isFetchingCollectablePdf: PropTypes.bool,
  isConfirmingForm: PropTypes.bool
};

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig,
    },
    form: {
      isConfirmingForm
    },
    questionnaires: {
      formQuestionnaire,
    }
  } = state;

  return {
    isConfirmingForm,
    formTypes: onlineConfig && onlineConfig.formTypes,
    showAffidavit: formQuestionnaire?.blocks?.find(b => b.id === 'signer')?.answers?.generateAffidavit === 'true'
  };
}

// export default FormConfirmation;

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(FormConfirmation));
